import { FaShoppingBag, FaRegHeart, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

export default function UserDropdown({
  isLoggedIn,
  user,
  setUser,
  closeMenu,
  openModal,
}) {
  const navigate = useNavigate();

  const getInitials = (user) => {
    if (!user) return "";

    return `${user.first_name?.[0] || ""}${user.last_name?.[0] || ""}`.toUpperCase();
  };

  function capitalizeWords(str = "") {
    return str
      .split(" ")
      .map(
        (word) =>
          word.charAt(0).toUpperCase() +
          word.slice(1).toLowerCase()
      )
      .join(" ");
  }

  return (
    <div
      className="
        absolute
        top-full
        right-[-20px]
        w-96
        h-96
        bg-white
        border
        border-[#D8C8B5]
        rounded-lg
        shadow-xl
        z-50
        flex
        flex-col
        justify-between
      "
    >
      {/* =========================
          TOP SECTION
      ========================= */}

      <div
        className={`
          p-6
          text-center
          ${
            !isLoggedIn
              ? "flex flex-col justify-center items-center h-full"
              : "mt-5"
          }
        `}
      >
        {isLoggedIn ? (
          <>
            {/* Welcome */}
            <h1 className="text-[#3B2A1F] font-medium mb-5">
              Welcome Back!
            </h1>

            {/* User Initials */}
            <div
              className="
                w-16
                h-16
                mx-auto
                rounded-full
                bg-[#0F766E]
                flex
                items-center
                justify-center
                text-white
                text-xl
                font-bold
                mb-4
                shadow-lg
              "
            >
              {getInitials(user)}
            </div>

            {/* User Name */}
            <p className="font-semibold text-[#3B2A1F] mb-4">
              <span className="text-sm text-[#6B5746]">
                You are logged in as
              </span>

              <br />

              {capitalizeWords(user.first_name)}{" "}

              <span className="text-[#0F766E]">
                {capitalizeWords(user.last_name)}
              </span>
            </p>

            {/* Logout */}
            <button
              onClick={() => {
                setUser(null);
                localStorage.removeItem("user");
                closeMenu();
                window.location.href = "/";
              }}
              className="
                w-80
                bg-[#3B2A1F]
                text-white
                py-2
                rounded
                font-semibold
                hover:bg-[#115E59]
                hover:-translate-y-1
                hover:shadow-lg
                transition-all
                duration-200
              "
            >
              Logout
            </button>
          </>
        ) : (
          <>
            {/* Logo */}
            <img
              src={logo}
              alt="A1 Rugs"
              className="w-20 h-auto mb-2"
            />

            {/* User Icon */}
            <div
              className="
                w-24
                h-24
                rounded-full
                border-4
                border-[#0F766E]
                flex
                items-center
                justify-center
                mb-5
                bg-[#F8F3EA]
              "
            >
              <FaUser className="text-[#8A7765] text-5xl" />
            </div>

            {/* Login Message */}
            <p className="font-semibold text-[#3B2A1F] mb-4">
              You are not logged in yet
            </p>

            {/* Login */}
            <button
              onClick={openModal}
              className="
                w-80
                bg-[#3B2A1F]
                text-white
                py-2
                rounded
                font-semibold
                hover:bg-[#0F766E]
                hover:-translate-y-1
                hover:shadow-lg
                transition-all
                duration-200
              "
            >
              Log in
            </button>
          </>
        )}
      </div>

      {/* =========================
          BOTTOM NAV BUTTONS
      ========================= */}

      <div
        className="
          grid
          grid-cols-2
          bg-[#0F766E]
          text-white
          rounded-b-lg
          overflow-hidden
        "
      >
        {/* =========================
            ORDERS
        ========================= */}

        <button
          onClick={() => {
            closeMenu();

            if (!isLoggedIn) {
              return openModal();
            }

            navigate("/orders");
          }}
          className="
            group
            flex
            items-center
            justify-center
            gap-2
            py-4
            transition-all
            duration-300
            hover:bg-[#115E59]
            hover:-translate-y-1
            active:scale-95
          "
        >
          <FaShoppingBag
            className="
              text-lg
              transition-transform
              duration-300
              group-hover:scale-110
              group-hover:rotate-3
            "
          />

          <span
            className="
              font-medium
              transition-colors
              duration-300
              group-hover:text-[#F8F3EA]
            "
          >
            Track Orders
          </span>
        </button>

        {/* =========================
            FAVORITES
        ========================= */}

        <button
          onClick={() => {
            closeMenu();

            if (!isLoggedIn) {
              return openModal();
            }

            navigate("/favourite");
          }}
          className="
            group
            flex
            items-center
            justify-center
            gap-2
            py-4
            border-l
            border-[#2A8A82]
            transition-all
            duration-300
            hover:bg-[#115E59]
            hover:-translate-y-1
            active:scale-95
          "
        >
          <FaRegHeart
            className="
              text-lg
              transition-transform
              duration-300
              group-hover:scale-110
              group-hover:text-[#F8F3EA]
            "
          />

          <span
            className="
              font-medium
              transition-colors
              duration-300
              group-hover:text-[#F8F3EA]
            "
          >
            My Favorites
          </span>
        </button>
      </div>
    </div>
  );
}